const COURSE_TYPES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default COURSE_TYPES_INITIAL_STATE
